<template>
  <div class="back-arrow-icon">
    <svg class="default" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path class="st0" d="M10,20C4.5,20,0,15.5,0,10S4.5,0,10,0s10,4.5,10,10-4.5,10-10,10ZM10,2C5.6,2,2,5.6,2,10s3.6,8,8,8,8-3.6,8-8S14.4,2,10,2Z" fill="currentColor"/>
      <path class="st0" d="M4.9,10c0-.2.1-.4.4-.7l3-3c.4-.4,1-.4,1.4,0s.4,1,0,1.4l-1.3,1.3h5.6c.6,0,1,.4,1,1s-.4,1-1,1h-5.6l1.3,1.3c.4.4.4,1,0,1.4s-1,.4-1.4,0l-3-3c-.3-.3-.4-.5-.4-.7Z" fill="currentColor"/>
    </svg>

    <svg class="hovered" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <circle class="st0" cx="10" cy="10" r="8" fill="currentColor" opacity="0.4"/>
      <path class="st1" d="M10,20C4.5,20,0,15.5,0,10S4.5,0,10,0s10,4.5,10,10-4.5,10-10,10ZM10,2C5.6,2,2,5.6,2,10s3.6,8,8,8,8-3.6,8-8S14.4,2,10,2ZM4.9,10c0-.2.1-.4.4-.7l3-3c.4-.4,1-.4,1.4,0s.4,1,0,1.4l-1.3,1.3h5.6c.6,0,1,.4,1,1s-.4,1-1,1h-5.6l1.3,1.3c.4.4.4,1,0,1.4s-1,.4-1.4,0l-3-3c-.3-.3-.4-.5-.4-.7Z" fill="currentColor"/>
    </svg>
  </div>
</template>

<style scoped>
.back-arrow-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.hovered {
  display: none;
}

.back-arrow-icon:hover .default {
  display: none;
}

.back-arrow-icon:hover .hovered {
  display: block;
}
</style>
